export const locale = {
    lang: 'es',
    data: {
        'AUTHENTICATION': {
            'INITIAL_TEXT': 'Acceder a tu cuenta',
            'EMAIL': 'Correo electrónico',
            'PASSWORD': 'Contraseña',
            'FORGOT_PASSWORD': '¿Olvidaste tu contraseña?',
            'LOGIN': 'Iniciar sesión',
            'NO_ACCOUNT': '¿No tienes cuenta todavía?',
            'CREATE_ACCOUNT': 'Crea una cuenta',
            'EMAIL_REQUIRED': 'Correo obligatorio',
            'INVALID_EMAIL': 'Por favor, inserta un correo válido',
            'PASSWORD_REQUIRED': 'Contraseña obligatoria',
            'WANT_VERIFY': '¿Quiere verificar un documento?',
            'DOCUMENT_VERIFICATION': 'Ir a verificación de documento'
        }
    }
};
